import Selector from "../../Selectors/Selector";
import { Box } from "@mantine/core";

const FilterField = ({
  field,
  fields,
  handleFieldChange,
  getFieldOptionName,
  isMobile,
  disableEdit,
}) => {
  return (
    <Box w={isMobile ? "100%" : 200}>
      <Selector
        options={fields}
        value={field?.id}
        onChange={handleFieldChange}
        size={"sm"}
        getOptionName={getFieldOptionName}
        hasGroup
        required
        unclearable
        withinPortal={true}
        offset={2}
        readOnly={disableEdit}
      />
    </Box>
  );
};

export default FilterField;
